import { render, staticRenderFns } from "./tianBao.vue?vue&type=template&id=1aff8148&scoped=true&"
import script from "./tianBao.vue?vue&type=script&lang=js&"
export * from "./tianBao.vue?vue&type=script&lang=js&"
import style0 from "./tianBao.vue?vue&type=style&index=0&id=1aff8148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff8148",
  null
  
)

export default component.exports